const subForm = document.querySelector('.sub-form');
const subFormError = document.querySelector('.sub-form__error');

const cleanErrorMessage = () => {
    subFormError.textContent = '';
    subFormError.classList.add('sub-form__error_hide');
    const subFormInputs = subForm.querySelectorAll('.sub-form__input');
    subFormInputs.forEach((subFormInput) => subFormInput.classList.remove('sub-form__input_theme_error'));
}

const validateEmail = (email) => {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
}

const validateNameLength = (name) => {
    return name.length > 1;
}

const validatePhoneLength = (phone) => {
    return phone.length > 9;
}

const showError = (message, formInput) => {
    subFormError.textContent = message;
    subFormError.classList.remove('sub-form__error_hide');
    formInput.classList.add('sub-form__input_theme_error');
}

const requestEvaluation = (event) => {
    event.preventDefault();
    cleanErrorMessage();

    const subFormInputEmail = subForm.querySelector('.sub-form__input[name="email"]');
    const subFormInputName = subForm.querySelector('.sub-form__input[name="name"]');
    const subFormInputPhone = subForm.querySelector('.sub-form__input[name="phone"]');

    if (!validateEmail(subFormInputEmail.value)) {
        showError('Please, input valid email address!', subFormInputEmail);
        return;
    }
    if (!validateNameLength(subFormInputName.value)) {
        showError('Name should contain more than one letter!', subFormInputName);
        return;
    }
    if (!validatePhoneLength(subFormInputPhone.value)) {
        showError('Phone number length should contain more than 9 digits!', subFormInputPhone);
        return;
    }
    event.currentTarget.submit();
}

subForm.addEventListener('submit', requestEvaluation)
